<div class="base-layout-container flex h-full flex-col items-start overflow-auto" [class.use-dark-theme]="false">
    <div class="flex w-full grow flex-col self-stretch">
        <app-global-warning></app-global-warning>
    </div>
    <div class="flex grow flex-col self-center p-5">
        <router-outlet></router-outlet>
    </div>
</div>
